/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monsterplanfullname7d3Inputs */



/**
* | output |
* | --- |
* | "'Monster', 7 days" |
*
* @param {Monsterplanfullname7d3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const monsterplanfullname7d3 = /** @type {((inputs?: Monsterplanfullname7d3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monsterplanfullname7d3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("'Monster', 7 days")
	if (locale === "es") return /** @type {LocalizedString} */ ("«Monster», 7 días")
	return /** @type {LocalizedString} */ ("«Монстр», 7 дней")
});
export { monsterplanfullname7d3 as "monsterPlanFullName7d" }